import { render } from "./LogoWrapper.vue?vue&type=template&id=199f9023&scoped=true"
import script from "./LogoWrapper.vue?vue&type=script&lang=js"
export * from "./LogoWrapper.vue?vue&type=script&lang=js"

import "./LogoWrapper.vue?vue&type=style&index=0&id=199f9023&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199f9023"]])

export default __exports__